// inspired with https://raw.githubusercontent.com/twbs/bootstrap/v4-dev/js/@app/modal.js
// but simplified

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
import $ from 'jquery'

const Modal = (($) => {
  const NAME = 'sfModal'
  const DATA_KEY = 'sf.modal'
  const EVENT_KEY = `.${DATA_KEY}`
  const ESCAPE_KEYCODE = 27

  const Selector = {
    CONTAINER: '.sf-modal-container',
    BACKDROP: '.sf-modal-backdrop',
    DATA_DISMISS: '[data-dismiss="sf-modal"], [data-dismiss="modal"]',
  }

  const Event = {
    CLICK_DISMISS: `click.dismiss${EVENT_KEY}`,
    KEYDOWN_DISMISS: `keyup.dismiss${EVENT_KEY}`,
  }

  class Modal {
    constructor(element, onHide, canClose) {
      this._element = element
      this._container = $(element).find(Selector.CONTAINER)[0]
      this._backdrop = $(element).find(Selector.BACKDROP)[0]
      this._isShown = false
      this._onHide = onHide
      this._canClose = canClose
      this._inFocus = true
    }

    show() {
      if (this._isShown) {
        return
      }

      this._isShown = true
      this._inFocus = true

      this._setEscapeEvent()

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, (event) =>
        this.hide(event)
      )

      $([this._container, this._backdrop]).on(Event.CLICK_DISMISS, (event) => {
        if (event.target !== event.currentTarget) {
          return
        }
        this.hide()
      })

      this._showElement()
    }

    hide(event) {
      if (event) {
        event.preventDefault()
      }

      if (!this._isShown) {
        return
      }

      if (this._canClose && !this._canClose()) {
        return
      }

      this._isShown = false

      this._setEscapeEvent()

      $(this._element).off(Event.CLICK_DISMISS)

      this._hideModal()

      if (this._onHide) {
        this._onHide()
      }
    }

    unFocusModal() {
      this._inFocus = false
    }

    focusModal() {
      this._inFocus = true
    }

    _showElement() {
      if (
        !this._element.parentNode ||
        this._element.parentNode.nodeType !== Node.ELEMENT_NODE
      ) {
        // don't move modals dom position
        document.body.appendChild(this._element)
      }

      this._element.style.display = 'block'
      this._element.removeAttribute('aria-hidden')
      this._element.scrollTop = 0
    }

    _setEscapeEvent() {
      if (this._isShown) {
        $(document).on(Event.KEYDOWN_DISMISS, (event) => {
          if (event.which === ESCAPE_KEYCODE && this._inFocus) {
            this.hide()
          }
        })
      } else if (!this._isShown) {
        $(document).off(Event.KEYDOWN_DISMISS)
      }
    }

    _hideModal() {
      this._element.style.display = 'none'
      this._element.setAttribute('aria-hidden', true)
    }

    static _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        let data = $(this).data(DATA_KEY)
        const _config = $.extend(
          {},
          $(this).data(),
          typeof config === 'object' && config
        )

        if (!data) {
          data = new Modal(this, _config.onHide, _config.canClose)
          $(this).data(DATA_KEY, data)
        }

        if (_config.show) {
          data.show(relatedTarget)
        }
      })
    }
  }

  $.fn[NAME] = Modal._jQueryInterface
  $.fn[NAME].Constructor = Modal

  return Modal
})($)

export default Modal
